import { render, staticRenderFns } from "./HasBrandbotTag.vue?vue&type=template&id=06cc52b1&scoped=true&"
import script from "./HasBrandbotTag.vue?vue&type=script&lang=js&"
export * from "./HasBrandbotTag.vue?vue&type=script&lang=js&"
import style0 from "./HasBrandbotTag.vue?vue&type=style&index=0&id=06cc52b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc52b1",
  null
  
)

export default component.exports